<template>
  <div id="other-income-result-container">
    <span class="is-size-5">RETIREMENT INCOME</span>
    <div class="columns">
      <div class="column">
        <div class="has-text-centered">
          <div id="spending-result-content" v-html="getContentSnippet('other-income-result-content')">
          </div>
          <div class="columns">
            <div class="column has-text-right">
              <div id="income-list-container" class="has-text-centered is-pulled-right">
                <ul>
                  <li>Part-time job</li>
                  <li>Pension</li>
                  <li>Inheritance</li>
                </ul>
              </div>
            </div>
            <div id="additional-income-button-container" class="column has-text-left">
              <button @click="setIncomeEditMode" class="button is-secondary">Add Additional Income</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'getContentSnippet'
    ])
  },
  methods: {
    ...mapActions({
      setEditMode: 'setEditMode'
    }),
    setIncomeEditMode: function () {
      this.setEditMode('income')
      this.$router.push({ path: 'home' })
    }
  }
}
</script>

<style lang="scss" scoped>
  #income-list-container {
    width: 150px;
    border: 1px #ffc400 solid;
    border-radius: 3px;
    padding: 10px 0px;
  }
  #additional-income-button-container a {
    margin-top: 30px;
  }
</style>
